import { render, staticRenderFns } from "./NewsHome.vue?vue&type=template&id=c2de72b8"
import script from "./NewsHome.vue?vue&type=script&lang=js"
export * from "./NewsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports